import { useNavigate } from 'react-router-dom';

import ForwardArrowIcon from '@/shared-components/icons/components/public/ForwardArrowIcon';
import Text from '@/shared-components/text/components/Text';

import ArtworkImage from './ArtworkImage';

import './styles/VerifyGalleryArtworkCard.css';

export default function VerifyGalleryArtworkCard({ artworkData }) {
  const navigate = useNavigate();

  return (
    <div
      className="verify-gallery-artwork-card"
      onClick={() =>
        navigate('/verify-gallery/preview', {
          state: { draftData: artworkData, from: true },
        })
      }
    >
      <ArtworkImage
        image={artworkData.draft_container.artwork_media.artwork_main_picture.image_id}
        imageClassName="verify-gallery-artwork-card__image"
        imageTemplateClassName="verify-gallery-artwork-card__image-template"
      />
      <div className="verify-gallery-artwork-card__info-container">
        {/* bloque meta: título + artista */}
        <div className="verify-gallery-artwork-card__meta">
          <Text className="verify-gallery-artwork-card__title font-size-medium" paragraph>
            {artworkData.draft_container.artwork_about.artwork_title}
          </Text>

          <Text
            className="verify-gallery-artwork-card__artist font-size-medium"
            paragraph>
            {artworkData.draft_container.artwork_about.artwork_artist.artist_name}
          </Text>
        </div>

        {/* bloque status: pill */}
        <div
          className={`verify-gallery-artwork-card__info-status-card ${
            artworkData.draft_status === 'pending'
              ? '--pending'
              : artworkData.draft_status === 'changes_required'
                ? '--changes'
                : artworkData.draft_status === 'rejected'
                  ? '--rejected'
                  : '--verified'
          }`}
        >
          <Text
            className="verify-gallery-artwork-card__artwork-status-text font-size-small">
            {artworkData.draft_status === 'pending'
              ? 'Under review'
              : artworkData.draft_status === 'changes_required'
                ? 'Changes required'
                : artworkData.draft_status === 'rejected'
                  ? 'Declined'
                  : 'Verified'}
          </Text>
        </div>
      </div>
      <ForwardArrowIcon className="verify-gallery-artwork-card__enter-form-icon" />
    </div>
  );
}
